import '../../en/video-center/style/video-center.scss'

let renderingPage = 1;
let data;
let markData = {
  category: 'Vídeos de instrução',
  filterTag: {
    model: '',
    videoType: [],
  },
  pages: 1,
  pageSize: 12,
  totalPages: 1,
  showPages: 5
}
let filterData = []


let radioBox = $('input[name=model]')
let checkboxBox = $('input[name=video-type]')
let sureBtn = $('.btn-sure')
let videoCategorys = $('.video-category-item')





const filterVideo = () => {
  return data.filter(item => {
    return item.category === markData.category
  }).filter(item => {
    if (markData.category === 'Vídeos de instrução' && (markData.filterTag.model.length || markData.filterTag.videoType.length)) {
      return [...item.tag.model, ...item.tag.videoType].some(tag => {
        return markData.filterTag.model.includes(tag) || markData.filterTag.videoType.includes(tag)

      })
    } else {
      return true
    }
  })
}

const searchVideo = (value) => {
  return data.filter(item => {
    if (item.title.includes(value)) {
      return item
    }
  })

}





const render = (fn) => {
  $('.video-list').empty()
  $('.page-number').empty()
  let categorys = fn()
  let totalPages = Math.ceil(categorys.length / markData.pageSize)
  markData.totalPages = totalPages

  if (categorys.length) {
    $('.video-content-null').hide()
  } else {
    $('.video-content-null').show()
  }

  let currentNum = categorys.slice((markData.pages - 1) * markData.pageSize, markData.pages * markData.pageSize)
  currentNum.forEach(item => {
    $(`
  <li dataId="${item.videoUrl}" dataUrl="${item.url || ''}" class="video-box">
    <div class="video-poster">
      <img src="${item.imgUrl}"
        alt="" />
      <div class="img-masker">
        <span class="iconfont icon-play"></span>
      </div>
    </div>
    <div class="video-text">
      <h3 class="video-title">${item.title}</h3>
    </div>
  </li>
  
  `).appendTo('.video-list');
  })

  let start
  if (markData.pages <= markData.showPages - 2) {
    start = 2
  } else if (markData.pages > markData.totalPages - markData.showPages + 2) {
    start = markData.totalPages - markData.showPages + 2
  } else {
    start = markData.pages - parseInt((markData.showPages - 2) / 2)

  }
  if (markData.totalPages > markData.showPages) {
    let bool = markData.pages <= markData.showPages - 2 === false && markData.pages > markData.totalPages - markData.showPages + 2 === false;
    let renderPage = start + (markData.showPages - 2)
    $(`<div class="page-item ${1 == markData.pages && 'page-active'}" data-page="${1}">1</div>`).click(function () {
      markData.pages = $(this).text()
      render(fn)
    }).appendTo('.page-number');
    (markData.pages > (markData.totalPages - markData.showPages + 2) || bool) && $(`<div class="page-item">...</div>`).appendTo('.page-number')
    for (let i = start; i < renderPage; i++) {
      $(`<div class="page-item ${i == markData.pages && 'page-active'}" data-page="${i}">${i}</div>`).click(function () {
        markData.pages = $(this).text()
        render(fn)
      }).appendTo('.page-number')
    }
    (markData.pages <= markData.showPages - 2 || bool) && $(`<div class="page-item">...</div>`).appendTo('.page-number')
    $(`<div class="page-item ${markData.totalPages == markData.pages && 'page-active'}" data-page="${markData.totalPages}">${markData.totalPages}</div>`).click(function () {
      markData.pages = $(this).text()
      render(fn)
    }).appendTo('.page-number')
  } else if (markData.totalPages > 1 && markData.totalPages <= markData.showPages) {
    for (let i = 1; i <= markData.totalPages; i++) {
      $(`<div class="page-item ${i == markData.pages && 'page-active'}" data-page="${i}">${i}</div>`).click(function () {
        markData.pages = $(this).text()
        render(fn)
      }).appendTo('.page-number')
    }
  }
  if (window.scrollY > 0) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

}



$.getJSON('https://resource.qifeizn.com/resources/os/download/get/video-data-pt.json', function (v) {
  data = v
  render(filterVideo)
})



const cancelSelect = () => {
  if (!markData.filterTag.model && !markData.filterTag.videoType.length) {
    radioBox.each(function () {
      this.checked = false
    })
    checkboxBox.each(function () {
      this.checked = false
    })
  } else {
    radioBox.each(function () {
      if (this.value !== markData.filterTag.model) {
        this.checked = false
      } else {
        this.checked = true
      }
    })
    checkboxBox.each(function () {
      if (markData.filterTag.videoType.indexOf(this.value) === -1) {
        this.checked = false
      } else {
        this.checked = true
      }
    })
  }
}


const isPopups = () => {
  $('.filter-bottom-box .cover').toggle()
  $('.filter-icon').toggleClass('rotate').is('.rotate');
  return $('.filter-bottom-box').toggleClass('show-box').is('.show-box');
}

const resetFilter = function () {
  let bool = isPopups()
  if (!bool) {
    cancelSelect()
  }
}

$('.video-category-item').click(function () {
  videoCategorys.removeClass('category-active')
  $(this).addClass('category-active')
  let text = $(this).text()
  markData.category = text
  if (text === 'Vídeos de instrução') {
    $('.video-filter').show()
  } else {
    $('.video-filter').hide()
  }
  markData.pages = 1
  render(filterVideo)
})


$('.video-filter').click(resetFilter)
$('.btn-cancel').click(resetFilter)
$('.btn-reset').click(function () {
  markData.filterTag = {
    model: '',
    videoType: [],
  }
  cancelSelect()
})

sureBtn.click(function () {
  markData.pages = 1
  renderingPage = 1
  markData.filterTag = {
    model: '',
    videoType: [],
  }
  radioBox.each(function () {
    if (this.checked) {
      markData.filterTag.model = this.value
    }
  })
  checkboxBox.each(function () {
    if (this.checked) {
      markData.filterTag.videoType.push(this.value)
    }
  })

  isPopups()
  render(filterVideo)
})


$('.video-search input').keydown(function (e) {
  if (e.keyCode !== 13) return
  let value = $(this).val()
  if (value) {
    render(() => searchVideo(value))
  } else {
    render(filterVideo)
  }


})





$(".main .video-close").click(function () {
  $(".main .video-mask").hide();
  $(".main .video-mask video").attr("src", "");
});

$('body').on('click', '.video-content li', function () {
  let url = $(this).attr("dataUrl");
  if (url) {
    let origin = location.origin
    // 编码
    url = encodeURIComponent(url);
    window.open(origin + `/pt/B100-compilation-video.html`, '_blank');
    return;
  }

  var videoUrl = $(this).attr("dataId");
  $(".main .video-mask").show();
  $(".main .video-mask").css({
    display: "flex",
  });
  $(".main .video-mask video").attr("src", videoUrl);
})


$('.filter-bottom-box .cover').click(function () {
  $(this).hide()
  $('.filter-icon').removeClass('rotate')
  $('.filter-bottom-box').removeClass('show-box')
})

